
import types from "../mutation-types";
import MeetingApi from '../../api/meetings'

export const state = {
    meetings: [],
    meta: {
        count: 0,
        currentPage: 1,
        pageSize: 15
    },
    uiFlags: {
        isFetching: false,
        isCreating: false,
        isDeleting: false,
        isUpdating: false,
    },
    meeting_reports:[],

    // meeting by contact
    meetingsByContact_meta: {
        count: 0,
        current_page: 1,
        page_size: 15,
        reports:{},
    },
    meetingsByContact_uiFlags: {
        isFetching: false,
        // isCreating: false,
        // isDeleting: false,
        // isUpdating: false,
    },
    meetingsByContact_reports:[],

};

// list of getters
const getters = {
    getUIFlags(_state){
        return _state.uiFlags;
    },
    getMeta(_state){
        return _state.meta;
    },
    getMeetings(_state){
        return _state.meetings;
    },
    getMeetingReports(_state){
        return _state.meeting_reports;
    },

    // meeting by contact
    getMeetingsByContact(_state){
        return _state.meetingsByContact_reports;
    },
    getMeetingsByContactMeta(_state){
        return _state.meetingsByContact_meta;
    },
    getMeetingsByContactUIFlags(_state){
        return _state.meetingsByContact_uiFlags;
    },
}


// actions list
const actions = {
    getMeetings: async function({commit,state},query){
        commit(types.SET_MEETINGS_UI_FLAG,{isFetching: true});
        try {
            const response = await MeetingApi.getAllMeetings(query);
            commit(types.SET_MEETING_LIST, response.data?.data);
            commit(types.SET_MEETINGS_UI_FLAG,{isFetching: false});
        } catch (error) {
            console.log(error);
            commit(types.SET_MEETINGS_UI_FLAG,{isFetching: false});
        }
    },
    getMeetingReports: async function({commit},queryParams={}){
        commit(types.SET_MEETINGS_UI_FLAG,{isFetching: true});
        try {
            const {data} = await MeetingApi.getMeetingReport(queryParams);
            commit(types.SET_MEETING_REPORTS,data);
            commit(types.SET_MEETINGS_UI_FLAG,{isFetching: false});
            return data;
        } catch (error) {
            commit(types.SET_MEETINGS_UI_FLAG,{isFetching: false});
        }
    },

    getMeetingReportByContact: async function({commit,state},queryParams={}){
        commit(types.SET_MTNG_BY_CONTACT_UIFLAG,{isFetching: true});
        try {
            const {data} = await MeetingApi.getMeetingReportByContact(queryParams);
            const newMeta = {
                ...state.meetingsByContact_meta,
                ...data.meta,
            }
            commit(types.SET_MTNG_BY_CONTACT_REPORTS,data.data);
            commit(types.SET_MTNG_BY_CONTACT_META,newMeta);
            commit(types.SET_MTNG_BY_CONTACT_UIFLAG,{isFetching: false});
            return data;
        } catch (error) {
            commit(types.SET_MTNG_BY_CONTACT_UIFLAG,{isFetching: false});
            throw error;
        }
    },

}


// list of mutations
const mutations = {
    // mutate UI flags
    [types.SET_MEETINGS_UI_FLAG](_state, data) {
        _state.uiFlags = {
          ..._state.uiFlags,
          ...data,
        };
    },

    [types.SET_MEETING_LIST]($state, data) {
        $state.meetings = data;
    },

    // set meeting reports
    [types.SET_MEETING_REPORTS]($state,data){
        $state.meeting_reports = data;
    },

    // set meeting by contact reports
    [types.SET_MTNG_BY_CONTACT_REPORTS]($state,data){
        $state.meetingsByContact_reports = data;
    },

    // set meeting by contact meta
    [types.SET_MTNG_BY_CONTACT_META]($state,data){
        $state.meetingsByContact_meta = data;
    },

    // set meeting by contact ui flags
    [types.SET_MTNG_BY_CONTACT_UIFLAG]($state,data){
        $state.meetingsByContact_uiFlags = {
            ...$state.meetingsByContact_uiFlags,
            ...data,
        };
    },
}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}